export function domainsMatchFromAndSmtp(fromAddress: string, smtpUsername: string): boolean {
  try {
    const fromDomain = fromAddress.split('@')[1]?.toLowerCase();
    const smtpDomain = smtpUsername.split('@')[1]?.toLowerCase();
    if (fromDomain && smtpDomain) {
      return fromDomain === smtpDomain;
    }
    return true;
  } catch {
    return false;
  }
}
